import { Briefcase, Code, HeartHandshake, Megaphone, Settings, ShieldCheck, ShoppingBag, MessageCircle } from "lucide-react";
import { useCompanyContact, waLink } from "../lib/companyContact";

const WA_MSG =
  "Hola RivoNes, me interesa aplicar para una posición. Mi nombre es: _____. La posición que me interesa es: _____. Adjunto mi CV.";

const AREAS = [
  { icon: Code, name: "Tecnología", desc: "Frontend, backend, móvil, infraestructura y datos." },
  { icon: HeartHandshake, name: "Atención al cliente", desc: "Soporte 24/7 a huéspedes y anfitriones." },
  { icon: Settings, name: "Operaciones", desc: "Logística, flotilla, verificación y gestión de incidentes." },
  { icon: Megaphone, name: "Marketing", desc: "Crecimiento, contenido, redes sociales y branding." },
  { icon: ShoppingBag, name: "Ventas", desc: "Adquisición de anfitriones y cuentas corporativas." },
  { icon: HeartHandshake, name: "Alianzas estratégicas", desc: "Partnerships con hoteles, agencias y aerolíneas." },
  { icon: ShieldCheck, name: "Verificación y soporte", desc: "Cumplimiento, KYC, fraude y disputas." },
];

export default function CarrerasPage() {
  const { contact } = useCompanyContact();
  return (
    <div className="min-h-screen bg-sand pb-16" data-testid="carreras-page">
      <div className="container-main py-10 max-w-3xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 text-emerald-600 flex items-center justify-center">
            <Briefcase className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-3xl font-heading font-bold text-agave">Carreras en RivoNes</h1>
            <p className="text-sm text-neutral-600">Únete al equipo de RivoNes. Estamos construyendo una nueva forma de movilidad en México.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8">
          {AREAS.map(({ icon: Icon, name, desc }) => (
            <div key={name} className="bg-white border border-neutral-200 rounded-xl p-4 flex items-start gap-3" data-testid={`carreras-area-${name.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5" />
              </div>
              <div>
                <p className="font-semibold text-agave">{name}</p>
                <p className="text-xs text-neutral-600">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="card-base bg-gradient-to-br from-emerald-50 to-white">
          <h2 className="font-heading font-semibold text-lg text-agave mb-2">¿Listo para postularte?</h2>
          <p className="text-sm text-neutral-700 mb-4">
            Envíanos tu CV por WhatsApp y nuestro equipo de talento se pondrá en contacto contigo.
          </p>
          <a
            href={waLink(contact.whatsapp_number, WA_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-medium px-5 py-2.5 rounded-xl transition-colors"
            data-testid="carreras-whatsapp-cta"
          >
            <MessageCircle className="w-5 h-5" />
            Enviar CV por WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
